import { useGetEmployeeMeQuery } from "../../../common/api/employee";
import { getGreeting } from "../../dashboardPage/utils/getGreeting";
import {
    useGetCertificatesQuery,
    useGetMultipleCertificatesExportQuery,
} from "../../../common/api/certificate";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useEstablishmentId } from "../../../common/utils/useEstablishmentId";
import Skeleton from "react-loading-skeleton";
import { useEmployeeId } from "../../../common/utils/useEmployeeId";
import {
    setIsLeftTagOpenIndex,
    setIsRightTagOpenIndex,
} from "../EmployeeInactiveSlice";
import React, { JSX, useEffect } from "react";
import { handleTagClickOutside } from "../../../common/utils/handleTagClickOutside";
import { EmployeeInactiveCertificates } from "./EmployeeInactiveCertificates";
import { EmployeeInactiveDownloadAllButton } from "./EmployeeInactiveDownloadAllButton";
import { DeleteAccountConfirmationModal } from "../modals/DeleteAccountConfirmationModal";
import { EmployeeInactiveDeleteLink } from "./EmployeeInactiveDeleteLink";
import { EmployeeInactiveNotification } from "./EmployeeInactiveNotification";
import { getUserFullName } from "../../../common/utils/getUserFullName";

export const EmployeeInactiveContent = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const leftTagRef = React.useRef<HTMLDivElement>(null);
    const rightTagRef = React.useRef<HTMLDivElement>(null);
    const {
        currentPage,
        itemsPerPage,
        isLeftTagOpenIndex,
        isRightTagOpenIndex,
        isDeleteAccountModalOpen,
    } = useAppSelector((state) => state.employeeInactive);
    const { data: employeeMeData } = useGetEmployeeMeQuery({});
    const {
        data: certificatesData,
        isLoading: certificatesDataIsLoading,
        isFetching: certificatesDataIsFetching,
    } = useGetCertificatesQuery({
        page: currentPage,
        items_per_page: itemsPerPage,
        filter: {
            status: "active",
            establishment_id: useEstablishmentId(),
        },
    });
    const { data: blobData } = useGetMultipleCertificatesExportQuery({
        filter: {
            employee_id: useEmployeeId(),
        },
    });

    useEffect(() => {
        const clickOutsideHandler = (event: MouseEvent): void => {
            handleTagClickOutside({
                functionGroupModalRef: leftTagRef,
                qualificationStandardModalRef: rightTagRef,
                isFunctionGroupModalOpen: isLeftTagOpenIndex,
                isQualificationStandardModalOpen: isRightTagOpenIndex,
                setIsFunctionGroupModalOpen: setIsLeftTagOpenIndex,
                setIsQualificationStandardModalOpen: setIsRightTagOpenIndex,
                dispatch,
                event,
            });
        };

        document.addEventListener("mousedown", clickOutsideHandler);

        return () => {
            document.removeEventListener("mousedown", clickOutsideHandler);
        };
    }, [isLeftTagOpenIndex, isRightTagOpenIndex, dispatch]);

    return (
        <>
            <h2 className={"p-employee-inactive__content__title"}>
                {getGreeting()}, {getUserFullName(employeeMeData?.user)}
            </h2>
            <EmployeeInactiveNotification employeeMeData={employeeMeData} />
            <EmployeeInactiveDeleteLink />
            <hr />
            {certificatesDataIsLoading || certificatesDataIsFetching ? (
                <Skeleton count={5} height={"14rem"} borderRadius={"1.5rem"} />
            ) : (
                <>
                    <EmployeeInactiveDownloadAllButton
                        certificatesData={certificatesData}
                        blobData={blobData}
                    />
                    <EmployeeInactiveCertificates
                        certificatesData={certificatesData}
                        isLeftTagOpenIndex={isLeftTagOpenIndex}
                        isRightTagOpenIndex={isRightTagOpenIndex}
                        leftTagRef={leftTagRef}
                        rightTagRef={rightTagRef}
                        dispatch={dispatch}
                    />
                    {isDeleteAccountModalOpen && (
                        <DeleteAccountConfirmationModal />
                    )}
                </>
            )}
        </>
    );
};
